import RpcService from "@/core/services/Rpc/RpcService";
import RpcResponse from "@/core/services/Rpc/RpcResponse";

class ContactsDAO {
    static async delete(id: number): Promise<RpcResponse> {
        return await RpcService.makeRequestSilent('contacts.delete', { id });
    }

    static async create(personId: number, contact: any): Promise<RpcResponse> {
        return await RpcService.makeRequestSilent('contacts.add', { personId, contact });
    }

    static async update(contact: any): Promise<RpcResponse> {
        return await RpcService.makeRequestSilent('contacts.update', { contact });
    }
}

export default ContactsDAO;
